module.exports = __webpack_public_path__ + "img/adivina_sin_fondo.7bb50c3b.svg";